import type { ReactNode } from 'react';
import { Spinner } from './Button';

export interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
}

export function EmptyState({ title, description, action, icon }: EmptyStateProps) {
  return (
    <div className="tg-card flex flex-col items-center gap-3 px-6 py-10 text-center">
      {icon ? <div className="text-tg-accent">{icon}</div> : null}
      <h2 className="text-lg font-semibold text-tg-text">{title}</h2>
      {description ? <p className="max-w-md text-sm text-tg-text-secondary">{description}</p> : null}
      {action}
    </div>
  );
}

export function LoadingBlock({ label = 'Загрузка…' }: { label?: string }) {
  return (
    <div className="tg-card flex items-center justify-center gap-3 px-6 py-10">
      <Spinner />
      <span className="text-sm text-tg-text-secondary">{label}</span>
    </div>
  );
}

export function ListSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="space-y-2" aria-busy="true" aria-label="Загрузка списка">
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className="tg-skeleton h-11 w-full" />
      ))}
    </div>
  );
}
